<!-- zoom.component.html -->
<div class="zoom-controls align-items-center">
  <!-- Left Scroll Button (Zoom Out) -->
  <button class="icon-btn" (click)="zoomOut()" [disabled]="!canZoomOut">
    <i class="fa fa-search-minus" [ngStyle]="{ color: isZoomOutActive ? '#fff' : '#FFFFFF80' }" aria-hidden="true"></i>
  </button>

  <!-- Zoom Slider -->
  <input
    id="zoomSlider"
    type="range"
    min="0.5"
    max="2"
    step="0.1"
    [value]="zoomLevel"
    class="zoom-slider"
    (input)="onZoomChange($event)" />

  <!-- Right Scroll Button (Zoom In) -->
  <button class="icon-btn" (click)="zoomIn()">
    <i class="fa fa-search-plus" aria-hidden="true" [ngStyle]="{ color: isZoomInActive ? '#fff' : '#FFFFFF80' }"></i>
  </button>

  <select
    class="zoom-dropdown f-12 _700 d-flex justify-content-center align-content-center text-center"
    [(ngModel)]="selectedZoomPercentage"
    (change)="onZoomDropdownChange($event)">
    <option *ngFor="let level of zoomLevels" class="f-12 _700" [value]="level">{{ level }}%</option>
  </select>
</div>
